import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  --sign-x: 0px;
  --sign-offset: 0px;
  --sign-pen-x: 0px;
  --sign-pen-y: 0px;
  --sign-pen-rotate: 0deg;
  position: relative;
  display: table;
  svg {
    --icon-color: ${({ theme }) => theme.primary.background};
    transform: translateX(var(--sign-x));
    path {
      &:first-child {
        transform-origin: 11.1% 80.5%;
        transform: translate(var(--sign-pen-x), var(--sign-pen-y)) rotate(var(--sign-pen-rotate)) translateZ(0);
      }
      &:last-child {
        stroke-dasharray: 14px;
        stroke-dashoffset: var(--sign-offset);
      }
    }
  }
`;
export const IconSign = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            gsap.to(wrapperRef.current, {
                keyframes: [
                    {
                        '--sign-offset': '14px',
                        duration: 0.1,
                    },
                    {
                        '--sign-x': '-7px',
                        '--sign-offset': '28px',
                        duration: 0.9,
                    },
                    {
                        '--sign-x': '0px',
                        '--sign-pen-x': '0px',
                        '--sign-pen-rotate': '0deg',
                        duration: 0.2,
                        clearProps: true,
                        onStart: () => {
                            gsap.to(wrapperRef.current, {
                                '--sign-pen-y': '-2px',
                                duration: 0.1,
                                repeat: 1,
                                yoyo: true,
                            });
                        },
                        onComplete: () => {
                            triggerDone();
                        },
                    },
                ],
            });
            gsap.to(wrapperRef.current, {
                keyframes: [
                    {
                        '--sign-pen-x': '2px',
                        '--sign-pen-y': '1.5px',
                        duration: 0.05,
                    },
                    {
                        '--sign-pen-x': '15px',
                        duration: 0.85,
                        delay: 0.05,
                    },
                ],
            });
            gsap.to(wrapperRef.current, {
                keyframes: [
                    {
                        '--sign-pen-y': '1.5px',
                        '--sign-pen-rotate': '-4deg',
                        duration: 0.1,
                        delay: 0.1,
                    },
                    {
                        '--sign-pen-y': '-1px',
                        '--sign-pen-rotate': '0deg',
                        duration: 0.1,
                        delay: 0.2,
                    },
                    {
                        '--sign-pen-y': '1.5px',
                        '--sign-pen-rotate': '4deg',
                        duration: 0.1,
                        delay: 0.1,
                    },
                    {
                        '--sign-pen-y': '0px',
                        '--sign-pen-rotate': '-4deg',
                        duration: 0.1,
                        delay: 0.15,
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Sign, null)));
};
//# sourceMappingURL=Sign.js.map